import styles from "components/Spinner/Spinner.module.scss";

const Spinner = () => {
  return (
    <div className={styles.container}>
      <div className={styles.ldsRipple}>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Spinner;
